import { render, staticRenderFns } from "./CourseQuizAssignment.vue?vue&type=template&id=33f663a4"
import script from "./CourseQuizAssignment.vue?vue&type=script&lang=js"
export * from "./CourseQuizAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports